export enum SignUpPriceEnum {
  Month = 'month',
  Year = 'year',
}
